import MailButton from '@components/MailButton';
import PhoneButton from '@components/PhoneButton';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { IoIosContact } from 'react-icons/io';

export default function ContactSeller() {
  const [showSeller, setShowSeller] = useState(false);
  const t = useTranslations('ContactSeller');

  return (
    <div className='p-6'>
      <button
        className='flex w-full items-center border-2 border-dark justify-center gap-3 text-white rounded-sm bg-black px-4 py-2 uppercase hover:bg-brand hover:text-black focus:bg-brand focus:text-black'
        onClick={() => setShowSeller(!showSeller)}
      >
        <span className='text-2xl'>
          <IoIosContact />
        </span>
        {t('buttonText')}
      </button>
      {showSeller && (
        <ul className='flex flex-col gap-1 pt-2'>
          <li>
            <PhoneButton />
          </li>
          <li>
            <MailButton />
          </li>
        </ul>
      )}
    </div>
  );
}
